<template>
  <div >
    <!-- 查询条件容器 -->
    <div ref="formContainer">
      <slot></slot> <!-- 页面原来的查询条件 -->
    </div>

    <!-- 展开/折叠图标 -->
    <div class="openBox" >
      <div class="openChild" @click="toggleTopShow" v-if="showCollapseIcon">
        <i :class="topShow ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"></i>
      </div>
    </div>
  </div>
</template>

<script>
// 查询条件必须有 formItemBox calss名称
export default {
  props: {
    desktopCount: { type: Number, default: 10 },
    mobileCount: { type: Number, default: 8 },
    formItemsLength: { type: Number, required: true }
  },
  data () {
    return {
      topShow: false,
      maxCount: 8
    }
  },
  computed: {
    showCollapseIcon () {
      return this.formItemsLength > this.maxCount
    }
  },
  watch: {
    formItemsLength (val) {
    // 接口数据回来之前一般是 0 / undefined
      if (!val) return
      this.$nextTick(() => {
        this.calcMaxCount()
      })
    }
  },
  mounted () {
    this.calcMaxCount()
    window.addEventListener('resize', this.calcMaxCount)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.calcMaxCount)
  },
  methods: {
    toggleTopShow () {
      this.topShow = !this.topShow
      this.updateVisibility()
    },
    calcMaxCount () {
      this.maxCount = window.innerWidth >= 1680 ? this.desktopCount : this.mobileCount

      // 判断是否需要折叠
      if (this.formItemsLength <= this.maxCount) {
        this.topShow = true
      } else {
        this.topShow = false
      }
      this.updateVisibility()
    },
    updateVisibility () {
      const container = this.$refs.formContainer
      if (!container) return
      const items = container.querySelectorAll('.formItemBox .el-form-item')
      items.forEach((item, index) => {
        if (this.topShow || index < this.maxCount) {
          item.style.display = ''
        } else {
          item.style.display = 'none'
        }
      })
      this.$nextTick(() => this.$emit('update-height'))
    }
  }
}
</script>

<style scoped>
.openBox{
  height: 12px;
}
</style>
